function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_330",
  "data-name": "Group 330",
  transform: "translate(-1692.764 -113.115)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_329",
  "data-name": "Group 329"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_328",
  "data-name": "Group 328"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_316",
  "data-name": "Group 316"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_402",
  "data-name": "Path 402",
  d: "M1695.149,135.717a.3.3,0,0,1-.152-.042.307.307,0,0,1-.142-.185l-2.081-7.772a.306.306,0,0,1,.217-.374l3.194-.855a.3.3,0,0,1,.231.031.309.309,0,0,1,.143.185l2.08,7.772a.306.306,0,0,1-.216.374l-3.194.855A.32.32,0,0,1,1695.149,135.717Zm-1.706-7.862,1.921,7.182,2.606-.7-1.923-7.182Z",
  fill: "#2d250c"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_317",
  "data-name": "Group 317"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_403",
  "data-name": "Path 403",
  d: "M1714.439,134.511h-.016l-16.293-.412a.306.306,0,0,1-.288-.227l-1.671-6.244a.3.3,0,0,1,.136-.34l13.9-8.5a.306.306,0,0,1,.322,0,.3.3,0,0,1,.14.288,24.477,24.477,0,0,0,3.972,14.9.3.3,0,0,1,.1.228A.305.305,0,0,1,1714.439,134.511Zm-16.066-1.018,15.466.392a25.45,25.45,0,0,1-3.823-14.267l-13.2,8.071Z",
  fill: "#2d250c"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_318",
  "data-name": "Group 318"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_404",
  "data-name": "Path 404",
  d: "M1719.024,137.684h0c-2.951,0-6.408-4.592-8.04-10.682-1.814-6.764-.8-12.715,2.306-13.549a2.8,2.8,0,0,1,.726-.1c2.956,0,6.411,4.592,8.039,10.682,1.815,6.763.8,12.715-2.3,13.549A2.83,2.83,0,0,1,1719.024,137.684Zm-5.008-23.715a2.2,2.2,0,0,0-.568.074c-2.683.72-3.542,6.583-1.874,12.8,1.538,5.736,4.81,10.23,7.45,10.23h0a2.182,2.182,0,0,0,.573-.075c2.681-.72,3.537-6.583,1.869-12.8C1719.933,118.461,1716.66,113.969,1714.016,113.969Z",
  fill: "#2d250c"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_319",
  "data-name": "Group 319"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_405",
  "data-name": "Path 405",
  d: "M1721.1,136.639a.3.3,0,0,1-.107-.019c-2.7-.995-5.455-5.2-6.866-10.458s-1.12-10.282.719-12.5a.306.306,0,0,1,.34-.091c2.7.992,5.455,5.2,6.866,10.464s1.122,10.284-.718,12.489A.305.305,0,0,1,1721.1,136.639Zm-5.919-22.408c-1.571,2.131-1.767,6.912-.462,11.773s3.861,8.9,6.282,9.961c1.569-2.123,1.766-6.9.462-11.768S1717.6,115.289,1715.184,114.231Z",
  fill: "#2d250c"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_320",
  "data-name": "Group 320"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_406",
  "data-name": "Path 406",
  d: "M1714.833,127.776a.3.3,0,0,1-.29-.213c-.164-.517-.3-.975-.413-1.4-.124-.454-.235-.92-.341-1.423a.308.308,0,0,1,.173-.34,6.844,6.844,0,0,1,1.126-.4,6.978,6.978,0,0,1,1.777-.249c1.228,0,2.068.4,2.251,1.079a1.641,1.641,0,0,1-.771,1.62,6.221,6.221,0,0,1-2.3,1.114,7.521,7.521,0,0,1-1.182.215Zm-.394-2.92c.087.4.18.777.281,1.146.093.353.2.725.33,1.136a7.454,7.454,0,0,0,.836-.168,5.621,5.621,0,0,0,2.07-1c.435-.358.643-.719.569-.989-.1-.376-.768-.629-1.66-.629a6.371,6.371,0,0,0-1.622.229A6.278,6.278,0,0,0,1714.439,124.856Z",
  fill: "#2d250c"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_321",
  "data-name": "Group 321"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_407",
  "data-name": "Path 407",
  d: "M1705.946,144.867a.3.3,0,0,1-.266-.158l-5.913-10.721a.307.307,0,0,1,.01-.31.316.316,0,0,1,.273-.143l3.627.182a.307.307,0,0,1,.251.157l5.178,9.3a.3.3,0,0,1,.021.248.3.3,0,0,1-.168.181l-2.893,1.235A.3.3,0,0,1,1705.946,144.867Zm-5.38-10.694,5.514,10,2.327-.994-4.93-8.861Z",
  fill: "#2d250c"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_322",
  "data-name": "Group 322"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_408",
  "data-name": "Path 408",
  d: "M1699.9,130.28a.306.306,0,0,1-.079-.6l9.566-2.566a.306.306,0,0,1,.156.591l-9.564,2.566A.342.342,0,0,1,1699.9,130.28Z",
  fill: "#2d250c"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_323",
  "data-name": "Group 323"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_409",
  "data-name": "Path 409",
  d: "M1725.694,122.651a.305.305,0,0,1-.08-.6l3.161-.846a.306.306,0,0,1,.374.216.3.3,0,0,1-.216.374l-3.16.846A.311.311,0,0,1,1725.694,122.651Z",
  fill: "#2d250c"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_324",
  "data-name": "Group 324"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_410",
  "data-name": "Path 410",
  d: "M1729.619,126.532h-3.266a.306.306,0,1,1,0-.611h3.266a.306.306,0,1,1,0,.611Z",
  fill: "#2d250c"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_325",
  "data-name": "Group 325"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_411",
  "data-name": "Path 411",
  d: "M1729.133,131.3a.286.286,0,0,1-.077-.01l-3.157-.846a.306.306,0,1,1,.159-.59l3.154.846a.305.305,0,0,1-.079.6Z",
  fill: "#2d250c"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_326",
  "data-name": "Group 326"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_412",
  "data-name": "Path 412",
  d: "M1721.558,116.037a.306.306,0,0,1-.215-.522l2.31-2.31a.3.3,0,0,1,.432,0,.308.308,0,0,1,0,.432l-2.311,2.31A.3.3,0,0,1,1721.558,116.037Z",
  fill: "#2d250c"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_327",
  "data-name": "Group 327"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_413",
  "data-name": "Path 413",
  d: "M1724.061,119.072a.305.305,0,0,1-.152-.57l2.833-1.632a.306.306,0,0,1,.306.529l-2.834,1.632A.291.291,0,0,1,1724.061,119.072Z",
  fill: "#2d250c"
})))));

var SvgNotification = function SvgNotification(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37.161,
    height: 31.752,
    viewBox: "0 0 37.161 31.752",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNotification, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/notification.2acd7a73.svg";
export { ForwardRef as ReactComponent };